export const oscills = [
  {
    text: "Spinner",
    typeClick: "line",
  },
  {
    text: "Toad",
    typeClick: "toad",
  },
  {
    text: "Beacon",
    typeClick: "beacon",
  },
  {
    text: "Penta-Deca",
    typeClick: "deca",
  },
  {
    text: "Pulsar",
    typeClick: "pulsar",
  },
];

export const ships = [
  {
    text: "Glider",
    typeClick: "glider",
  },
  {
    text: "Light-Weight",
    typeClick: "lwss",
  },
  {
    text: "Med. Weight",
    typeClick: "mwss",
  },
  {
    text: "Heavy-Weight",
    typeClick: "hwss",
  },
];

export const stills = [
  {
    text: "Square",
    typeClick: "square",
  },
  {
    text: "Tub",
    typeClick: "tub",
  },
  {
    text: "Hive",
    typeClick: "hive",
  },
  {
    text: "Loaf",
    typeClick: "loaf",
  },
  {
    text: "Boat",
    typeClick: "boat",
  },
];
